import { createSlice, createSelector } from '@reduxjs/toolkit'

const menuInitialState = {
    footer: [],
    middle: [],
    top: [],
    loaded: false,
    loading: false,
    error: null,
}

const menu = createSlice({
    name: 'menu',
    initialState: menuInitialState,
    reducers: {
        requestMenu(state) {
            state.loading = true
        },
        successMenu(state, { payload }) {
            if (payload) {
                const footer = payload?.footer ?? []
                const middle = payload?.middle ?? []
                const top = payload?.top ?? []
                state.top = top
                state.middle = middle
                state.footer = footer
                state.loaded = true
            }
            state.loading = false
            state.error = null
        },
        failureMenu(state, { payload }) {
            state.loading = false
            state.error = payload
        },
    },
})

export const fetchMenu = () => async (dispatch, getState, { api }) => {
    try {
        const menu = getState().menu
        if (menu.loaded) {
            dispatch(successMenu())
            return
        } else {
            dispatch(requestMenu())
            const resp = await api.menu()
            const { result = 'success', menu } = resp

            if (result === 'success') {
                const { footer, top, middle } = menu
                dispatch(successMenu({ footer, top, middle }))
            } else {
                dispatch(failureMenu(resp))
            }
        }
    } catch (err) {
        dispatch(failureMenu(err.toString()))
    }
}

export const getMenu = createSelector(
    state => state.menu,
    menu => {
        const { footer, top, middle } = menu
        return {
            footer, top, middle,
        }
    },
)

export const { requestMenu, successMenu, failureMenu } = menu.actions

export default menu.reducer
